import HeaderOfLeaderPortal from "../../utils/HeaderOfLeaderPortal";
import SearchOfLeaderPortal from "../../utils/SearchOfLeaderPortal";
import {useEffect, useState} from "react";
import {personalityRequest} from "../../../api/MoadianService";
import {
    companyRequests,
    companyRequestsSearch,
    personalityRequests,
    personalityRequestsSearch
} from "../../../api/LeaderPortalApi";
import {notify} from "../../utils";
import RightArrow from "../../icons/RightArrow";
import LeftArrow from "../../icons/LeftArrow";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import {PaginationItem} from "@mui/material";
import {changeDateToFarsi, getTransactionStatusNameTable} from "../../methods/TransactionStatusName";
import {toFarsiNumber} from "../../methods/CommonMethods";
import {Toaster} from "react-hot-toast";

export default function PersonalityRequests({setDetailId}) {

    const [data, setData] = useState();
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10)
    const [param, setParam] = useState("")
    const [statusTrans, setStatusTrans] = useState("NOT_CERT_ISSUED")
    const [totalPage, setTotalPage] = useState(0)
    const [isLoading, setIsLoading] = useState(false)

    const prevPage = () => {
        if(page > 1) {
            setPage(page - 1);
        }else{
            setPage(1)
        }
    }

    const nextPage = () => {
        if(page < totalPage) {
            setPage(page + 1)
        }else{
            setPage(totalPage)
        }
    }

    const tabFun = () => {
        setIsLoading(true)
        const searchPage = page - 1;
        if(param) {
            personalityRequestsSearch(statusTrans, param, searchPage, size).then(response => {
                console.log(response.data)
                setData(response.data.content)
                setTotalPage(response.data.totalPages)
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
                notify(error?.response?.data?.message)
            })
        }else{
            personalityRequests(statusTrans, searchPage, size).then( response => {
                setData(response.data.content)
                setTotalPage(response.data.totalPages)
                setIsLoading(false)
            }).catch( error => {
                setIsLoading(false)
                notify(error?.response?.data?.message)
            })
        }

    }

    useEffect( () => {
        tabFun();
    }, [page, size, statusTrans])

    useEffect( () => {
        setPage(1)
    }, [statusTrans, param, size])

    const exportExcel = () => {

    }


    const tabButtons = [
        {
            name: "کل درخواست‌ها",
            statusTrans: 'ALL_TRANSACTIONS'
        },
        {
            name: "صادر شده",
            statusTrans: 'CERT_ISSUED'
        },
        {
            name: "صادر نشده",
            statusTrans: 'NOT_CERT_ISSUED'
        },
    ]

    return(
        <>
            <Toaster/>
            <HeaderOfLeaderPortal
                title={`درخواست‌های حقیقی`}
                text={`آخرین درخواست های گواهی امضای دیجیتال را در این قسمت مشاهده می‌کنید`}
                exportFunction={exportExcel}
            />
            <SearchOfLeaderPortal
                tabButtons={tabButtons}
                colSize={`col-5`}
                activeBtnName={tabButtons[2].name}
                setSearchText={setParam}
                searchText={param}
                statusTrans={statusTrans}
                setStatusTrans={setStatusTrans}
                tabFun={tabFun}
            />


            <div className={`request-body-div px-4 mt-4`} style={{minHeight: "60vh"}}>
                <table className={`table table-borderless`}>

                    <thead>
                    <tr>
                        <th className={`text-center`}>کد پیگیری</th>
                        <th className={`text-center`}>کد ملی</th>
                        <th className={`text-center`}>نام و نام خانوادگی</th>
                        <th className={`text-center`}>شماره تلفن</th>
                        <th className={`text-center`}>تاریخ</th>
                        <th className={`text-center`}>وضعیت</th>
                        <th className={`text-center`}>عملیات</th>
                    </tr>

                    </thead>

                    <tbody>
                    {
                        data && data.length > 0 ?
                            (data.map((row, index) => (
                                <tr key={index} className={`tr_table`}>
                                    <td className={`text-center`}>{row.traceId}</td>
                                    <td className={`text-center`}>{row?.personInfo?.nationalId}</td>
                                    <td className={`text-center`}>{row?.personInfo?.firstName} {row?.personInfo?.lastName}</td>
                                    <td className={`text-center`}>{row?.personInfo?.phoneNumber}</td>
                                    <td className={`text-center`}>{changeDateToFarsi(row?.creatDate, true)}</td>
                                    <td className={`text-center`}>{getTransactionStatusNameTable(row.status)}</td>
                                    <td
                                        className={`text-center pointer`}
                                        style={{color: "#098791"}}
                                        onClick={ () => setDetailId(row.id)}
                                    >مشاهده جزییات</td>
                                </tr>
                            )))
                            :
                            (<tr className={`tr_table`}>
                                <td scope={6} className={`text-center`} style={{color: "grey"}}>اطلاعاتی ثبت نشده است.</td>
                            </tr>)
                    }
                    </tbody>

                </table>
            </div>

            <div className={`row w-100 justify-content-between mt-3`}>

                <div className={`col-3 p-0`}>
                    <button className={`btn btn-sm footer-btn`} onClick={nextPage}>
                        <RightArrow />
                        بعدی</button>
                    <button className={`btn btn-sm footer-btn`} onClick={prevPage}>
                        قبلی
                        <LeftArrow />
                    </button>
                </div>

                <div className={`col-3`}>
                    <Stack spacing={2}>
                        <Pagination
                            onChange={(event, value) => setPage(value)}
                            count={totalPage}
                            page={page}
                            size="small"
                            shape="rounded"
                            variant="outlined"
                            color="primary"
                            renderItem={(item) => (
                                <PaginationItem
                                    {...item}
                                    page={item.page !== null ? toFarsiNumber(item.page) : item.page}
                                />
                            )}
                        />
                    </Stack>
                </div>

                <div className={`col-3 footer-div`}>
                    <p>تعداد نمایش در هر صفحه</p>
                    <select className="form-select" onChange={(e) => setSize(e.target.value)}>
                        <option value="10">۱۰</option>
                        <option value="25">۲۵</option>
                        <option value="100">۱۰۰</option>
                        <option value="500">۵۰۰</option>
                    </select>
                </div>

            </div>

            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}
        </>
    )
}